import { CanDeactivateFn } from '@angular/router';
import { Observable } from 'rxjs';

export interface HierarchySetupCanDeactivate {
  canDeactivate: () => boolean | Observable<boolean>;
}

/** Ask before leaving the hierarchy setup with unsaved changes. */
export const hierarchySetupCanDeactivateGuard: CanDeactivateFn<HierarchySetupCanDeactivate> = (
  component,
) => component.canDeactivate();
